import React from 'react';
import EtatPrintPage from './EtatPrintPage';

export default function EtatCgmPrintPage() {
    return <EtatPrintPage mode="bureau" />;
}


